import Chatkit from '@pusher/chatkit-client';
import axios from 'axios';

function showDialog() {
  this.isDialogOpen = !this.isDialogOpen;
  this.components.nav_drawer.right = true;
}

function sendMessage() {
  const { newMessage, currentUser, currentRoom } = this;

  if (newMessage.trim() === '') return;

  currentUser.sendMessage({
    text: newMessage,
    roomId: `${currentRoom.id}`,
  });

  this.newMessage = '';
}

function connectToRoom(id, messageLimit = 100) {
  this.messages = [];
  const { currentUser } = this;

  return currentUser
    .subscribeToRoom({
      roomId: `${id}`,
      messageLimit,
      hooks: {
        onMessage: message => {
          this.messages = [...this.messages, message];
        },
      },
    })
    .then(currentRoom => {
      this.currentRoom = currentRoom;
    });
}

function addSupportStaffToRoom() {
  const { currentRoom, currentUser } = this;

  return currentUser.addUserToRoom({
    userId: 'support',
    roomId: currentRoom.id,
  });
}

function createRoom() {
  const { currentUser } = this;

  return currentUser
    .createRoom({
      name: currentUser.name,
      private: true,
    })
    .then(room => this.connectToRoom(room.id, 0))
    .then(() => this.addSupportStaffToRoom());
}

function launchChat() {
  this.isNameVisible = false;

  const { userId } = this;
  //Production
  //const UR = 'http://35.242.182.168:5200';
  //Test
  //const URL = 'http://192.168.1.71:5200';

  if (userId === null || userId.trim() === '') {
    alert('Invalid userId');
  } else {
    axios
      .post('http://localhost:5200/users', { userId })
      .then(() => {
        const tokenProvider = new Chatkit.TokenProvider({
          url: 'http://localhost:5200/authenticate',
        });

        const chatManager = new Chatkit.ChatManager({
          instanceLocator: 'v1:us1:7d4832cd-281d-4006-bcbe-2347557d75b2',
          userId,
          tokenProvider,
        });

        return chatManager.connect().then(currentUser => {
          this.currentUser = currentUser;
          this.isLoading = false;
          return this.createRoom();
        });
      })
      .catch(console.error);
  }
}

function handleInput(name, value) {
  console.log(name, value);
  this[name] = value;
}

export {
  sendMessage,
  connectToRoom,
  addSupportStaffToRoom,
  createRoom,
  handleInput,
  showDialog,
  launchChat,
};